import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text, Icon } from '../../../../../components';

const QuestionHistoryItemContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
`;

const QuestionHistoryItem = ({ question }) => (
  <QuestionHistoryItemContainer>
    <Icon name='bubble' displaySize={20} color='var(--content-subtitle)' />
    <Text>{question}</Text>
  </QuestionHistoryItemContainer>
);

QuestionHistoryItem.propTypes = {
  question: PropTypes.string.isRequired
};

export { QuestionHistoryItem };
